import { Code, ConnectError } from '@connectrpc/connect'

/**
 * `GetWorkflowCase` の取得失敗が「ワークフローが見つからない」 (spec AC-WFW-040) か
 * を判定する。
 *
 * backend は存在しない ID と他組織の ID をどちらも NotFound、形式が不正な ID を
 * proto validate の InvalidArgument で返す。spec は 3 種類を区別せず同じ表示にする
 * ため、両 code をまとめて「見つからない」とする。削除済みのワークフローは取得に
 * 成功する (= ここには来ない) ので、AC-WFW-014 の読み取り専用で開く。
 *
 * 通信エラー・サーバーエラー (Unavailable / Internal 等) は「見つからない」に
 * 含めない (再試行で直りうるため。AC-WFW-040 の対象外)。
 */
export function isWorkflowCaseNotFoundError(error: unknown): boolean {
  return (
    error instanceof ConnectError &&
    (error.code === Code.NotFound || error.code === Code.InvalidArgument)
  )
}
